import {Col, Container, Modal, Row} from "react-bootstrap";
import {AppContext} from "../../lib/AppContext";
import React, {useContext, useEffect, useState} from "react";
import MDButton from "../../components/MDButton";
import Grid from "@mui/material/Grid";
import {InputAdornment} from "@mui/material";
import MDInput from "../../components/MDInput";
import {useForm} from "react-hook-form";
import {adminConvertInvoice} from "../common/api/WebApi";

export default function ConvertInvoiceModal({invoice, show, handleSave, handleClose}) {

  const [context, setContext] = useContext(AppContext);
  const [saving, setSaving] = useState(false);

  const {register, handleSubmit, setValue, control, reset} = useForm({
  });

  useEffect(()=> {
    console.dir(invoice)
    setValue('originalPrice', invoice?.originalAmount);
    setValue('invoiceGk', invoice?.id);
  }, []);

  const handleFormSave = (data) => {
    console.dir(data);

    adminConvertInvoice(data).then((resp)=> {
      console.dir(resp);
      handleSave();
    })
  }

  const styles = {
    container: {
      maxWidth: '600px',
      backgroundColor: '#ffffff',
      margin: 'auto',
      border: '1px solid #ddd',
      borderRadius: '5px',
      padding: '20px'
    },
    headerTitle: {
      color: '#333',
      marginBottom: '10px'
    },
    headerSubtitle: {
      textAlign: 'center',
      marginTop: 0,
      color: '#666'
    },
    divider: {
      border: 'none',
      borderTop: '2px solid #111',
    },
    customerTable: {
      width: '100%',
      marginBottom: '20px'
    },
    labelCell: {
      fontWeight: 'bold',
      color: '#333',
      padding: '4px 0'
    },
    valueCell: {
      color: '#555',
      padding: '4px 0'
    },
    itemsTable: {
      width: '100%',
      borderCollapse: 'collapse',
      border: '1px solid #eee'
    },
    headerRow: {
      backgroundColor: '#f2f2f2'
    },
    tableHeader: {
      border: '1px solid #eee',
      padding: '8px'
    },
    tableHeaderRight: {
      border: '1px solid #eee',
      padding: '8px',
      textAlign: 'right'
    },
    tableCell: {
      border: '1px solid #eee',
      padding: '8px'
    },
    totalTable: {
      width: '100%',
      marginTop: '20px'
    },
    subtotalLabel: {
      textAlign: 'right',
    },
    subtotalValue: {
      textAlign: 'right'
    },
    totalLabel: {
      textAlign: 'right',
      fontWeight: 'bold',
      borderTop: '1px solid #eee'
    },
    totalValue: {
      fontWeight: 'bold',
      borderTop: '1px solid #eee',
      textAlign: 'right'
    },
    footerText: {
      textAlign: 'center',
      color: '#888',
      fontSize: '13px',
      marginTop: '30px'
    },
    footerLink: {
      color: '#0066cc',
      textDecoration: 'none'
    },
    hiddenHelper: {
      display: 'none',
      whiteSpace: 'nowrap',
      font: '15px courier'
    }
  };


  return (
    <Modal onHide={handleClose} size={'lg'} show={show}>
      <form onSubmit={handleSubmit(handleFormSave)} id={'cafeOptionForm'}>
        <Modal.Header closeButton>
          <Modal.Title>View Invoice</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <Col className={'col col-main'} xs={12}>
              <Container>

                <div style={styles.container} id="invoice-main">
                  <Grid container>
                    <Grid item xs={6}>
                      <h5 style={styles.headerTitle}>
                        {invoice?.companyName}
                      </h5>
                    </Grid>
                    <Grid item xs={6}>
                      <h5 style={{
                        ...styles.headerTitle,
                        textAlign: 'right'
                      }}>
                        Invoice
                      </h5>
                      <p style={{
                        ...styles.headerTitle,
                        textAlign: 'right'
                      }}>
                        Order ID: {invoice.referenceId}
                      </p>
                    </Grid>
                  </Grid>

                  <hr style={styles.divider}/>

                  <table style={styles.customerTable} cellSpacing="0" cellPadding="0">
                    <tbody>
                    <tr>
                      <td style={styles.valueCell}>
                        <b>Invoice To</b>
                        <br/>
                        <b>{invoice.customerName}</b>
                        <br/>
                        {invoice.customerEmail} | {invoice.customerPhone}
                      </td>
                    </tr>
                    </tbody>
                  </table>

                  {!invoice?.invoiceGroup &&
                        <MDInput type="text" step="0.01" required
                                 {...register('originalPrice', {
                                   valueAsDouble: true
                                 })}
                                 onChange={(e) => {
                                   let v = e.target.value.replace(/[^0-9.]/g, '');
                                   e.target.value = v;
                                 }}
                                 InputProps={{
                                   startAdornment: <InputAdornment position="start">
                                     <span className={'fa fa-dollar'}></span>
                                   </InputAdornment>,
                                 }}
                                 placeholder={"10.00"}
                                 autoComplete="off"
                                 className="form-control" id="originalPrice"
                                 label="Amount Due"/>
                  }


                </div>
              </Container>
            </Col>
          </Row>

        </Modal.Body>
        <Modal.Footer>
          <MDButton type="submit" color="secondary" disabled={saving}>
            Save
          </MDButton>
        </Modal.Footer>
      </form>
    </Modal>
  );
}